import React, { useCallback, useEffect } from "react";
import { SelectRolePopupStyles, MenuStyles } from './Style'
import { useSelector } from "react-redux";
import { RemoveDefaultRoleBtn, roleHooks, SelectDefaultRoleBtn } from ".";
import { Img, LightButton, LightButton2, SmallSpace, Space, XSmallSpace } from "styles/GlobalStyle";
import { Logout } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { app } from "router/routes";
import { ReactComponent as SchoolIcon } from 'assets/icons/School.svg'
import { SvgIcon } from "@mui/material";

const SelectRolePopup = (props) => {
    const { handleClose, anchorEl, open } = props

    const { user, defaultRole } = useSelector(state => state.user)
    const { user_data, default_user_roles } = user || {}

    const roleList = roleHooks.useRoleList()
    const updateDefaultRole = roleHooks.useUpdateDefaultRole()
    const removeDefaultRole = roleHooks.useRemoveDefaultRole()
    const selectRole = roleHooks.useSelectRole()

    const navigate = useNavigate()

    const { icon } = roleList[defaultRole?.role_name] || roleList["default"]

    const logoutRoles = useCallback(() => {
        handleClose()
        navigate(app.selectRole)
    }, [])

    const _selectRole = useCallback((role) => {
        selectRole(role)
        handleClose()
    }, [])

    return (
        <MenuStyles
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
        >
            <SelectRolePopupStyles>
                <div className="role-icon">
                    <Img src={icon} />
                    <div className="wrap-heder-logo">
                        <div className="header-logo">
                            {defaultRole?.affiliation_logo && default_user_roles ?
                                <Img src={defaultRole?.affiliation_logo} /> :
                                <SvgIcon component={SchoolIcon} inheritViewBox />
                            }
                        </div>
                    </div>
                </div>

                <div className="wrap-role-title">
                    <div className="role-title">
                        {defaultRole.role_label}
                    </div>
                    <div className="role-title">
                        {defaultRole.affiliation_name}
                    </div>
                    <SmallSpace />
                    {defaultRole?.user_roles == default_user_roles &&
                        <div className="role-sub-title" >
                            {"מוגדר כברירת מחדל"}
                        </div>}
                    <XSmallSpace />
                    <LightButton
                        variant="solid"
                        action={() => defaultRole?.user_roles == default_user_roles ? removeDefaultRole() : updateDefaultRole(defaultRole)}
                        label={defaultRole?.user_roles == default_user_roles ? "ביטול ברירת מחדל?" : "הגדר כברירת מחדל?"}
                        size="small"
                    />
                </div>
                <Space />
                <div className="role-content">
                    <div className="role-content-title">
                        {"התפקידים הנוספים שלך"}
                    </div>
                    <div className="role-items">
                        {user_data?.map((role) => {
                            const { role_label, role_name, user_roles, affiliation_name } = role
                            const roleItem = roleList[role_name] || roleList["default"]
                            const { icon } = roleItem

                            return (
                                <div className="role-item" onClick={() => _selectRole(role)}>
                                    <div className="role-details">
                                        <div className="role-item-icon">
                                            <Img src={icon} />
                                        </div>
                                        <div className="affiliation-and-label" >
                                            <div className="role-label" >
                                                {role_label}
                                            </div>
                                            <div className="role-label bold">
                                                {affiliation_name}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="logo-and-button">
                                        {user_roles == default_user_roles ?
                                            <RemoveDefaultRoleBtn /> :
                                            <SelectDefaultRoleBtn role={role} />
                                        }
                                        <div className="header-logo">
                                            {role?.affiliation_logo ?
                                                <Img src={role?.affiliation_logo} /> :
                                                <SvgIcon fontSize="small" component={SchoolIcon} inheritViewBox />
                                            }
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
                <div className="remove-default-role" onClick={logoutRoles}>
                    <Logout />
                    <div>
                        {`יציאה מפרופיל ${defaultRole.role_label}`}
                    </div>
                </div>
            </SelectRolePopupStyles>
        </MenuStyles>
    )
}

export default SelectRolePopup